import React from "react";
import Hero from "./hero";
import Navbars from "../Components/navbar";
import Secone from "./secone";
import Sectwo from "./sectwo";
import Secthree from "./secthree";
import Footer from "../Components/Footer";


const Servicelink = () => {
    return(
        <>   
        <Navbars />
        <Hero />
        <Secone />
        <Sectwo />
        <Secthree />
        <Footer />
        </>
    )
}

export default Servicelink;